import { type NavigateOptions } from "@tanstack/react-router";
import { type BoxyListIcon } from "@bfc-software/pallet";

export type CommandKinds =
  | { kind: "navigation"; to: () => NavigateOptions }
  // TODO: we aren't using this _yet_, but wanted to get head of enumerating the things we can
  // do inside the command palette.
  | { kind: "action"; handler: () => void };

export function getIconForKind(kind: CommandKinds): BoxyListIcon {
  switch (kind.kind) {
    case "navigation":
      return "link";
    case "action":
      return "box";
  }
}

export type Command = {
  id: string;
  title: string;
  keywords?: string[];
  kind: CommandKinds;
};

export function navigationCommand({
  id,
  title,
  to,
  keywords,
}: {
  id: string;
  title: string;
  to: NavigateOptions;
  keywords?: string[];
}): Command {
  return {
    id,
    title,
    keywords,
    kind: {
      kind: "navigation",
      to: () => to,
    },
  };
}
